import React, { useState } from "react";
import "./ActionsMenu.scss";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomTooltip from "../CustomTooltip/CustomTooltip";

export function ActionsMenu({ menuOptions, disabled = false }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="actions-menu">
      <IconButton onClick={handleClick} disabled={disabled}>
        <MoreVertIcon sx={{ color: disabled ? "disabled" : "#0098CD" }} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          elevation: 5,
          sx: {
            borderRadius: 2,
            mt: 1,
            minWidth: 150,
            "& .MuiMenuItem-root": {
              py: 1,
              "&:hover": { backgroundColor: "action.hover" },
            },
          },
        }}
      >
        {menuOptions?.filter(Boolean).map((menuOption) => {
          const item = (
            <MenuItem
              key={menuOption.label}
              disabled={menuOption.disabled}
              onClick={() => {
                if (!menuOption.disabled) {
                  menuOption.action();
                  handleClose();
                }
              }}
              className={
                menuOption.disabled ? "menu-item-disabled" : "menu-item-enabled"
              }
            >
              <ListItemIcon>{menuOption.icon}</ListItemIcon>
              <ListItemText primary={menuOption.label} />
            </MenuItem>
          );

          return menuOption.disabled && menuOption.tooltip ? (
            <CustomTooltip
              key={menuOption.label}
              tipLabel={item}
              dataTip={menuOption.tooltip}
            />
          ) : (
            item
          );
        })}
      </Menu>
    </div>
  );
}
